import algoliasearch from 'algoliasearch';

// Connect and authenticate with your Algolia app
const algoliaClient = algoliasearch(
  'NKM8U7F5EA',
  '98679c23f231680e5ff028263d811d74'
);

export const companiesIndex = algoliaClient.initIndex('production_symbols');

export default algoliaClient;
